import { Box, DropdownOptions, TooltipPopup } from 'dash-ui';

import Container from 'flow-components/Container/Container';
import Header from 'flow-components/Header/Header';

import OrganizationDetailsPage from './OrganizationDetailsPage/OrganizationDetailsPage';

const OrganizationPage = () => {
  return (
    <Box w="100%">
      <DropdownOptions />
      <TooltipPopup />
      <Header />
      <Container>
        <Box w="100%">
          <OrganizationDetailsPage />
        </Box>
      </Container>
      <Box mb={10} />
    </Box>
  );
};

export default OrganizationPage;
